import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProcessModelType } from "../../../types/Finance";

const initialState: ProcessModelType = {
  status: false,
  idSchoolBankConfig: '',
  processName: '',
};

const processModelSlice = createSlice({
  name: "processModel",
  initialState,
  reducers: {
    setProcessModelData: (state, action: PayloadAction<ProcessModelType>) => ({
      ...state,
      ...action.payload,
    }),
    resetProcessModelData: () => ({ ...initialState }),
  },
});

export const { setProcessModelData, resetProcessModelData } = processModelSlice.actions;
export default processModelSlice.reducer;